import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpEditProjectDisabilityProfiles, HttpEditProjectDisabilityProfilesOptions} from '../http/projects.http'

export const useEditProjectDisabilityProfiles = ({
    urlParams,
    options
}: {
    urlParams: HttpEditProjectDisabilityProfilesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpEditProjectDisabilityProfilesOptions['payload']>
}) => {
    return useMutation({
        mutationFn: payload => httpEditProjectDisabilityProfiles({urlParams, payload}),
        ...options
    })
}
